export default __webpack_public_path__ + "static/media/remove_note.04e9e582.svg";